const crf250rallyData = {
  slug: "crf250-rally",
  name: "Honda CRF250 Rally",

  hero: {
    shortDescription:
      "Motor adventure rally 250cc dengan DNA Dakar, siap menjelajah jarak jauh dan medan ekstrem",

    variants: [
      {
        key: "black",
        label: "Extreme",
        fullName: "Honda CRF250 Rally Extreme Black",
        startPrice: 93527000,
      },
      {
        key: "red",
        label: "Extreme",
        fullName: "Honda CRF250 Rally Extreme Red",
        startPrice: 93527000,
      },
    ],

    slides: [
      {
        variantKey: "black",
        image: "/assets/motor/produk/crf250rally/Honda-CRF250-Rally-Extreme-Black.webp",
        specs: {
          engine: "249,6 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "18,3 kW (24,8 PS) / 9.000 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "red",
        image: "/assets/motor/produk/crf250rally/Honda-CRF250-Rally-Extreme-Red.webp",
        specs: {
          engine: "249,6 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "18,3 kW (24,8 PS) / 9.000 rpm",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CRF250 Rally merupakan motor adventure yang terinspirasi langsung dari motor reli Honda di ajang Dakar, dirancang untuk perjalanan jarak jauh dan eksplorasi medan berat.",
      },
      {
        type: "paragraph",
        text:
          "Mengusung mesin 250cc DOHC berpendingin cairan, CRF250 Rally memberikan performa bertenaga namun tetap nyaman dan stabil untuk perjalanan on-road maupun off-road.",
      },
      {
        type: "heading",
        text: "Desain Rally Dakar",
      },
      {
        type: "paragraph",
        text:
          "Tampilan khas rally dengan fairing tinggi, windshield besar, dan dual LED headlight memberikan perlindungan optimal dari angin serta visibilitas maksimal saat berkendara.",
      },
      {
        type: "heading",
        text: "Siap Touring & Off-Road",
      },
      {
        type: "paragraph",
        text:
          "Suspensi panjang Showa, ground clearance tinggi, dan tangki bahan bakar besar membuat CRF250 Rally ideal untuk touring jarak jauh dan petualangan lintas medan.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "249,6 cc"],
      ["Daya Maksimum", "18,3 kW (24,8 PS) / 9.000 rpm"],
      ["Torsi Maksimum", "23,1 Nm / 6.500 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Semi Double Cradle"],
      ["Suspensi Depan", "Showa USD Long Travel"],
      ["Suspensi Belakang", "Showa Pro-Link Monoshock"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "2.230 x 920 x 1.415 mm"],
      ["Tinggi Jok", "895 mm"],
      ["Jarak Sumbu Roda", "1.455 mm"],
      ["Berat", "152 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "12,8 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CRF250 Rally",
    items: [
      {
        title: "Mesin 250cc DOHC",
        desc:
          "Mesin bertenaga dengan karakter halus dan torsi kuat untuk touring dan off-road.",
      },
      {
        title: "Rally Fairing & Windshield",
        desc:
          "Fairing tinggi dan windshield besar untuk perlindungan maksimal saat perjalanan jauh.",
      },
      {
        title: "Dual LED Headlight",
        desc:
          "Lampu depan LED ganda dengan pencahayaan optimal khas motor rally.",
      },
      {
        title: "Showa Long Travel Suspension",
        desc:
          "Suspensi depan dan belakang Showa dengan travel panjang untuk meredam medan ekstrem.",
      },
      {
        title: "Tangki Bahan Bakar Besar",
        desc:
          "Kapasitas 12,8 liter yang mendukung jarak tempuh lebih jauh.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital informatif yang mendukung kebutuhan petualangan.",
      },
      {
        title: "Rangka Semi Double Cradle",
        desc:
          "Rangka kokoh yang dirancang khusus untuk stabilitas dan daya tahan off-road.",
      },
    ],
  },
};

export default crf250rallyData;
